if (typeof window.addIconCart === 'undefined') {
  window.addIconCart = function(e, variantId, btn) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }

    var origHTML = btn.innerHTML;
    var productCard = btn.closest('.grid-product__content');
    var productTitleNode = productCard ? productCard.querySelector('.grid-product__title') : null;

    function performIconAdd() {
      btn.innerHTML = '<span style="font-size: 14px; font-weight: bold;">...</span>';
      btn.disabled = true;

      var rootUrl = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';

      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
      .then(function(response) {
        if (!response.ok) throw new Error('Cart request failed');

        document.dispatchEvent(new Event('ajaxProduct:added'));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));

        if (typeof theme !== 'undefined' && theme.cart && typeof theme.cart.getCart === 'function') {
          theme.cart.getCart();
        } else if (typeof ajaxCart !== 'undefined' && typeof ajaxCart.load === 'function') {
          ajaxCart.load();
        }

        btn.innerHTML = '<span style="font-size: 14px; font-weight: bold;">✓</span>';
        setTimeout(function() {
          btn.innerHTML = origHTML;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function() {
        btn.innerHTML = origHTML;
        btn.disabled = false;
        if (productCard) window.location.href = productCard.querySelector('a').href;
      });
    }

    if (typeof window.astroidaRequestDuplicateConfirmation === 'function') {
      window.astroidaRequestDuplicateConfirmation({
        variantIds: [variantId],
        productTitle: productTitleNode ? productTitleNode.textContent.trim() : '',
        submitter: btn,
        onConfirm: performIconAdd,
        onCancel: function() {
          btn.innerHTML = origHTML;
          btn.disabled = false;
        }
      });
    } else {
      performIconAdd();
    }

    return false;
  };
}
